/**
 * Touching a monster kills (02 §3 Death). Ported from the end of the IRQ's sprite handler
 * (D_1CBD, L_1D32..L_1D79): after every sprite has moved, each player in normal play (state 1)
 * dies if any monster sprite in states 1..$0A - dropping in, waiting, walking, escaping; not in a
 * bubble, not frozen by the power heart ($16/$17) - is within |Ex - (Px+2)| < 12 and |Ey - (Py+2)| < 12.
 * Player 2 is tested first. Under the clock the monsters stand still but this test still runs.
 * A player the water carries is in state $0D (the catch loop L_1BD2 sets it), so touching is safe then.
 */

import { live } from './anger';
import { carriedByWater } from '../bubbles';
import { CONTACT_OFFSET, CONTACT_RANGE } from './tuning';
import { killPlayer } from '../players';
import type { PlayerId, World } from '../types';

const PLAYERS_P2_FIRST: readonly PlayerId[] = [1, 0];

/**
 * One contact test. A player respawning is in another state on the C64 (not 1), so the
 * invulnerable are skipped here as well as in `killPlayer`; so are the players under the power heart
 * (D_34A0 puts every player in play in state $18, and a respawn goes straight back to it:
 * check_player_state, `lda D_5A7F; bne L_0502`).
 */
export function touchPlayers(world: World): void {
  if (world.power.heart >= 0) return;
  for (const id of PLAYERS_P2_FIRST) {
    const p = world.players[id];
    if (p.state !== 'play' || p.invulnerable > 0 || carriedByWater(world, id)) continue;
    const px = p.x + CONTACT_OFFSET;
    const py = p.y + CONTACT_OFFSET;
    const touching = world.monsters.some(
      (m) => live(m) && Math.abs(m.x - px) < CONTACT_RANGE && Math.abs(m.y - py) < CONTACT_RANGE,
    );
    if (touching) killPlayer(world, id);
  }
}
